/* Luzzart · Artigo do blog v5. Sem dependências. O índice e os blocos já vêm prontos do Liquid; aqui só:
   - --lza-top: a altura do cabeçalho fixo do tema (índice fixo e rolagem para o título ficam abaixo dele);
   - o item do índice da seção que está na tela ganha destaque (IntersectionObserver);
   - tocar num item do índice "Neste guia" (celular) fecha o bloco. */
(function () {
  'use strict';
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var root = q('.lza-main');
  if (!root) return;

  // cabeçalho fixo do tema ("sticky" ao rolar para cima): o índice fixo e o scroll-margin acompanham
  function headerBottom() {
    var h = document.getElementById('shopify-section-header-1') || q('.hdr_wrap') || q('header');
    if (!h) return 0;
    var alvo = h, cs = getComputedStyle(alvo);
    if (cs.position !== 'fixed' && cs.position !== 'sticky') return 0;
    return Math.max(0, Math.round(alvo.getBoundingClientRect().bottom));
  }
  function setTop() {
    var sticky = /sticky_hdr/.test((document.getElementById('shopify-section-header-1') || {}).className || '');
    var top = sticky ? headerBottom() + 16 : 24;
    root.style.setProperty('--lza-top', Math.max(24, top) + 'px');
    qa('.lze').forEach(function (e) { e.style.setProperty('--lza-top', Math.max(24, top) + 'px'); });
  }
  setTop();
  var h1 = document.getElementById('shopify-section-header-1');
  if (h1 && window.MutationObserver) new MutationObserver(setTop).observe(h1, { attributes: true, attributeFilter: ['class', 'style'] });
  window.addEventListener('resize', setTop);

  // destaque do índice
  var links = qa('.lza-toc a[data-lza-toc]');
  if (links.length && 'IntersectionObserver' in window) {
    var alvos = links.map(function (a) { return document.getElementById(decodeURIComponent((a.getAttribute('href') || '').slice(1))); });
    var visivel = {};
    function pinta() {
      var ativo = -1;
      alvos.forEach(function (el, i) { if (el && visivel[i]) ativo = ativo === -1 ? i : ativo; });
      if (ativo === -1) {
        // nenhum título à vista: o último que já passou
        alvos.forEach(function (el, i) { if (el && el.getBoundingClientRect().top < window.innerHeight * 0.3) ativo = i; });
      }
      links.forEach(function (a, i) { a.classList.toggle('is-on', i === ativo); if (i === ativo) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current'); });
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { visivel[alvos.indexOf(e.target)] = e.isIntersecting; });
      pinta();
    }, { rootMargin: '-15% 0px -70% 0px' });
    alvos.forEach(function (el) { if (el) io.observe(el); });
  }

  // índice do celular fecha ao tocar num item
  qa('.lza-toc-m a').forEach(function (a) {
    a.addEventListener('click', function () { var d = a.closest('details'); if (d) d.removeAttribute('open'); });
  });
})();
